import { ValueFormatterParams } from '@ag-grid-community/core'
import { format } from 'date-fns'
import i18next from 'i18next'
import path from 'path'

import enTranslation from '../locales/en.json'
import { statusCodeToStatusName } from './Status'
import {
  contentTypeCodeToContentTypeName,
  jobTypeCodeToJobTypeName,
  langCodeToLangName,
  projectTypeCodeToProjectTypeName,
  userRoleCodeToUserRoleName
} from './Utils'

i18next.init({
  lng: 'en',
  debug: false,
  resources: {
    en: {
      translation: enTranslation
    }
  }
})

export const ContentTypeFormatter = (params: ValueFormatterParams): string => {
  return contentTypeCodeToContentTypeName(params.value)
}

export const DateTimeFormatter = (params: ValueFormatterParams): string => {
  if (typeof params.value === 'string') {
    return format(Date.parse(params.value), 'yyyy-MM-dd HH:mm:ss')
  }
  return ''
}

export const EmptyCellFormatter = (params: ValueFormatterParams): string => {
  return ''
}

export const JobNameFormatter = (params: ValueFormatterParams): string => {
  return params.value ? path.basename(params.value) : ''
}

export const JobTypeFormatter = (params: ValueFormatterParams): string => {
  return jobTypeCodeToJobTypeName(params.value)
}

export const LanguageNameFormatter = (params: ValueFormatterParams): string => {
  return langCodeToLangName(params.value)
}

export const ProjectTypeFormatter = (params: ValueFormatterParams): string => {
  return i18next.t(projectTypeCodeToProjectTypeName(params.value))
}

export const StatusNameFormatter = (params: ValueFormatterParams): string => {
  return i18next.t(statusCodeToStatusName(params.value))
}

export const OrganizationTypeFormatter = (params: ValueFormatterParams): string => {
  switch (params.value) {
    case 'owner-group':
      return 'MISUMI'
    case 'vendor':
      return 'Vendor'
    case 'cistate':
      return 'Cistate'
    default:
      return params.value
  }
}

export const IsEnabledFormatter = (params: ValueFormatterParams): string => {
  if (params.value === true) {
    return i18next.t('有効')
  } else if (params.value === false) {
    return i18next.t('無効')
  }
  return ''
}

export const BooleanFormatter = (params: ValueFormatterParams): string => {
  if (params.value === true) {
    return '✔'
  }
  return ''
}

export const UserRoleFormatter = (params: ValueFormatterParams): string => {
  return userRoleCodeToUserRoleName(params.value)
}
